<template>
  <activity-view
    :action-label="actionLabel"
    :show-entity-info="showEntityInfo"
    :show-team-org-name="showTeamOrgName"
    :activity="activity"
    :theme-color="themeColor"
    :comment="activity.comment"
    :goal="goal"
    @reacted="$emit('reacted')"
  >
    <div v-if="activity.outcome && activity.outcome !== 'none'">
      {{ entityName }} Outcome:
      <span class="variant bold" :data-variant="colorVariant" data-apply-color>{{
        getOutcomeLabel(activity.outcome)
      }}</span>
    </div>
  </activity-view>
</template>

<script>
import ActivityView from '@/components/activity/ActivityView'
import { VARIANT_MAP } from '@/constants/common'
import { ENTITY_TYPE } from '@/constants/entities'
import { GOAL_EVENT_TYPE } from '@/constants/goal'
import ActivityMixin from '@/mixins/ActivityMixin'
import getOutcomeLabel from '@/utils/getOutcomeLabel'

/**
 * This component gives view for close/reopen activity of goal/kr
 *
   @emits
 * - reacted
 */
export default {
  name: 'OutcomeActivity',
  props: ['activity', 'showTeamOrgName', 'themeColor', 'showEntityInfo', 'goal'],
  mixins: [ActivityMixin],
  components: {
    ActivityView
  },
  data() {
    return {}
  },
  computed: {
    action() {
      if (this.activity.type === GOAL_EVENT_TYPE.CLOSED) return 'closed'
      else if (this.activity.type === GOAL_EVENT_TYPE.REOPENED) return 're-opened'
      return null
    },
    actionLabel() {
      return `${this.action} the ${this.entityName}`
    },
    entityName() {
      const entityMap = {
        [ENTITY_TYPE.GOAL]: 'Goal',
        [ENTITY_TYPE.KEY_RESULT]: 'Key result',
        [ENTITY_TYPE.INITIATIVE]: 'Initiative'
      }
      return entityMap[this.entityType]
    },
    colorVariant() {
      return VARIANT_MAP['outcome-' + this.activity.outcome]
    }
  },
  methods: {
    getOutcomeLabel
  },
  mounted() {}
}
</script>
<style lang="scss" scoped>
@import '~@/styles/_goals.scss';
</style>
